import React from 'react'
import { withStyles } from '@material-ui/core'
import { Translation } from 'react-i18next'
import {
  Field,
  Form,
  useWatch,
  useForm,
  useFieldArray,
  WatchField,
  setFieldValue
} from '../../form'
import { expenseValidate } from '../../containers/validate'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'
import {
  getExpenseRows
} from '../expenses/newExpense.component'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import mobileView from '../../utils/mobile.utils'
import Consent from '../expenses/consent.component'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { useDispatch } from 'react-redux'
import ModalComponent from '../layout/modal.component'

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  switch: {
    position: 'relative',
    marginLeft: '10px',
    fontSize: '18px',
    fontWeight: '600',
    color: 'black'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  buttonFile: {
    marginTop: '45px',
    whiteSpace: 'nowrap'
  },
  table: {
    minWidth: 500
  },
  tablecell1: {
    minWidth: 40,
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'black',
    paddingRight: '10px !important',
    paddingLeft: '10px !important',
    paddingBottom: 3
  },
  button: {
    margin: theme.spacing(1),
    marginRight: 0
  },
  button1: {
    margin: 25
  },
  checkbox: {
    // marginTop: theme.spacing(2),
    fontSize: '14px',
    color: '#808080',
    fontWeight: 500
  }
})

const rowDefaultValues = {
  description: '',
  sum: '',
  vat: 25.5,
  sumWithoutVat: 0,
  cost_type: ''
}

const date = new Date()
const defaultValues = {
  place_of_purchase: '',
  date_of_purchase: date,
  decisionSelect: '',
  consent: false,
  inputFile: '',
  expenseInputRow: [rowDefaultValues],
  receipt_picture: ''
}

const AddCostForm = ({
  classes,
  invoiceFormControl,
  resetForm,
  saveExpense,
  showSnackbar,
  showFailSnackbar,
  errorStatus,
  closeExpenseSnackBar,
  getValuesInvoiceForm,
  enableExpenseBackBtn,
  isSaveAllowance,
  errMessage,
  disableExpenseBackBtn
}) => {
  const dispatch = useDispatch()

  const form = useForm({
    name: 'expense',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: expenseValidate
  })

  const { control, setValue, clearErrors } = form

  const [isDialogOpen, setIsDialogOpen] = React.useState(false)

  function onSubmit(values) {
    saveExpense(values)
    setIsDialogOpen(false)
  }

  const rowState = useFieldArray({
    name: 'expenseInputRow',
    control: control
  })

  const groupInvoiceCheck = useWatch({
    fields: 'groupInvoice',
    control: invoiceFormControl
  })
  const addAllowanceCheck = useWatch({
    fields: 'addAllowance',
    control: invoiceFormControl
  })

  const { fields } = rowState

  function addRow() {
    rowState.append(rowDefaultValues)
  }

  function removeRow(index) {
    rowState.remove(index)
  }

  const handleCheckAddCost = (e) => {
    const isChecked = e.target.checked

    if (isChecked) {
      setIsDialogOpen(true)
      enableExpenseBackBtn(getValuesInvoiceForm())
    } else if (!isChecked) {
      setIsDialogOpen(false)
      resetForm('expense')
      disableExpenseBackBtn()
    }
  }

  const handleCloseDialog = () => {
    dispatch(
      setFieldValue('invoice', {
        field: 'addCost',
        value: false
      })
    )
    setIsDialogOpen(false)
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="row">
            <div className="dashboard-content-header">
              <div className="col-xs-12 col-sm-12 col-lg-12">
                <div
                  className="panel panel-default"
                  style={{
                    border: '1px solid #AEE0E7',
                    padding: '5px',
                    borderRadius: '10px'
                  }}
                >
                  <div>
                    <Field
                      name="addCost"
                      label={t('invoice.button8')}
                      inputType="switch"
                      control={invoiceFormControl}
                      className={classes.switch}
                      onChange={(e) => handleCheckAddCost(e)}
                      disabled={
                        groupInvoiceCheck.groupInvoice ||
                        addAllowanceCheck.addAllowance
                          ? true
                          : false
                      }
                    />
                  </div>
                  <ModalComponent
                    open={isDialogOpen}
                    onClose={handleCloseDialog}
                    content={
                      <div className="container-fluid">
                        <div className="row">
                          <div
                            className="central-text"
                            style={{
                              fontSize: '20px',
                              fontWeight: 1000,
                              padding: '15px'
                            }}
                          >
                            {t('newExpenc.h1a')}
                          </div>
                        </div>

                        {/*Add cost form*/}
                        <div className="row">
                          <div
                            className="panel-title-cost"
                            style={{ padding: '8px', overflowX: 'auto' }}
                          >
                            {t('newExpenc.h3')}
                          </div>
                        </div>
                        <div>
                          <Form {...form}>
                            <div className="row">
                              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <Field
                                  name="place_of_purchase"
                                  inputType="textfield"
                                  label={t('newExpenc.label2') + '*'}
                                  control={control}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                />
                              </div>
                              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <Field
                                  name="date_of_purchase"
                                  inputType="datepicker"
                                  label={t('newExpenc.label3') + '*'}
                                  control={control}
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                />
                              </div>
                              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <Field
                                  name="receipt_picture"
                                  label={t('newExpenc.label10')}
                                  placeholder={t('newExpenc.holder2')}
                                  control={control}
                                  disabled={true}
                                  inputType="textfield"
                                  className={classNames(
                                    classes.textField,
                                    classes.resize
                                  )}
                                />
                              </div>
                              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div>
                                  <Button
                                    variant="contained"
                                    className={classes.buttonFile}
                                    component="label"
                                    htmlFor="input-tax"
                                  >
                                    {t('newExpenc.label4')}
                                  </Button>
                                </div>
                                <div className="dashboard-tax-input">
                                  <Field
                                    label={'kkk'}
                                    name="inputFile"
                                    inputType="file"
                                    id="input-tax"
                                    control={control}
                                    onChange={(e) => {
                                      setValue(
                                        'receipt_picture',
                                        e.target.value
                                          .split('\\')
                                          .slice(-1)
                                          .pop()
                                      )
                                      clearErrors('receipt_picture')
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              {mobileView
                                ? expenseTableMobile(
                                    classes,
                                    fields,
                                    addRow,
                                    removeRow,
                                    control,
                                    setValue
                                  )
                                : expenseTable(
                                    classes,
                                    fields,
                                    addRow,
                                    removeRow,
                                    control,
                                    setValue
                                  )}
                            </div>
                            <div className="row">
                              <div className="col-xs-12 col-sm-12 col-lg-12">
                                <WatchField
                                  control={control}
                                  fields="decisionSelect"
                                >
                                  {(watch) => (
                                    <>
                                      <Field
                                        name="decisionSelect"
                                        inputType="checkbox-for-strings"
                                        className={classes.checkbox}
                                        control={control}
                                        label={t(
                                          'decisionDialog.addToInvoice2'
                                        )}
                                        // onChange={onChange}
                                        stringValue="add_to_invoice"
                                      />
                                      <div>
                                        <p
                                          className={
                                            watch.decisionSelect ===
                                            'add_to_invoice'
                                              ? 'visible'
                                              : 'invisible'
                                          }
                                        >
                                          {t('decisionDialog.addToInvoiceDesc')}
                                        </p>
                                      </div>
                                    </>
                                  )}
                                </WatchField>
                                <div style={{ marginLeft: '-21px' }}>
                                  <Consent
                                    classes={classes}
                                    control={control}
                                    invoiceItemType="expense"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="pull-right">
                                <Button
                                  variant="contained"
                                  className={classes.button1}
                                  type="submit"
                                  // onClick={() => setAttemptingSubmit(true)}
                                >
                                  {t('newExpenc.label7')}
                                </Button>
                              </div>
                            </div>
                          </Form>
                        </div>
                      </div>
                    }
                    maxWidth="1200px"
                  />
                </div>
              </div>
            </div>
            {/*Add costs and Add allowances use same snack bar at invoice form*/}
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeExpenseSnackBar()
                // history.push('/dashboard/fee')
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeExpenseSnackBar()
                  // history.push('/dashboard/fee')
                }}
                variant="success"
                message={
                  isSaveAllowance
                    ? t('newAllowComponent.msg4')
                    : t('newExpenc.msg4')
                }
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showFailSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeExpenseSnackBar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeExpenseSnackBar()
                }}
                variant="error"
                message={
                  isSaveAllowance
                    ? errMessage ===
                      'Error: Miles allowances box checked, and no vehicle type was selected'
                      ? t('newAllowComponent.vehicleFailMsg')
                      : t('newAllowComponent.failMsg')
                    : errorStatus === 400
                    ? t('newExpenc.failMsg')
                    : t('newExpenc.msg3')
                }
              />
            </Snackbar>
          </div>
        )
      }}
    </Translation>
  )
}

const expenseTable = (
  classes,
  fields,
  addRow,
  removeRow,
  control,
  setValue
) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.root} style={{ padding: '5px' }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tablecell1}
                  style={{ width: '50%' }}
                >
                  {t('newExpenc.costs')}*
                </TableCell>
                <TableCell
                  className={classes.tablecell1}
                  style={{ width: '80%' }}
                >
                  {t('newExpenc.table')}*
                </TableCell>
                <TableCell
                  className={classes.tablecell1}
                  style={{ maxWidth: '50%' }}
                >
                  {t('newExpenc.table2')}*
                </TableCell>
                <TableCell className={classes.tablecell1}>
                  {t('newExpenc.table3')}
                </TableCell>
                <TableCell
                  className={classes.tablecell1}
                  style={{ maxWidth: '140px' }}
                >
                  {t('newExpenc.sumWithoutVat')}
                </TableCell>
                <TableCell className={classes.tablecell1}>
                  {/* {t('newExpenc.table4')} */}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getExpenseRows(fields, removeRow, control, setValue)}
            </TableBody>
          </Table>
          <div style={{ marginRight: '10px' }}>
            <div className="pull-right">
              <Button
                variant="outlined"
                className={classes.button}
                onClick={addRow}
              >
                {t('newExpenc.label8')}
              </Button>
            </div>
          </div>
        </div>
      )
    }}
  </Translation>
)

const expenseTableMobile = (
  classes,
  fields,
  addRow,
  removeRow,
  control,
  setValue
) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.root}>
          {getExpenseRows(fields, removeRow, control, setValue)}
          <div
            className={
              !mobileView ? 'dashboard-invoice-add pull-right' : 'pull-right'
            }
          >
            <Button
              variant="outlined"
              className={classes.button}
              onClick={addRow}
              style={mobileView ? { marginRight: 15 } : null}
            >
              {t('newExpenc.label8')}
            </Button>
          </div>
        </div>
      )
    }}
  </Translation>
)

export default withStyles(styles)(AddCostForm)
